import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import locale from "@bonliva-crm/locale";

export interface Props {
  open: boolean;
  anchor: Element;

  onClose: () => void;
  onEdit: () => void;
  onUpload: () => void;
  onDuplicate: () => void;
  onPublish: () => void;
  onNullify: (value: boolean) => void;
  onDelete: () => void;
  onOpenInOneflow: () => void;

  canUnNullify: boolean;
  canNullify: boolean;
  canEdit: boolean;
  canUpload: boolean;
  canPublish: boolean;
  canOpenInOneflow: boolean;
}

export const SnapshotRowMenu = (props: Props) => {
  return (
    <Menu anchorEl={props.anchor} open={props.open} onClose={props.onClose}>
      <MenuItem onClick={props.onEdit} disabled={!props.canEdit}>
        {locale.Edit}
      </MenuItem>

      <MenuItem onClick={props.onUpload} disabled={!props.canUpload}>
        {locale.UploadSignedDocument}
      </MenuItem>

      <MenuItem onClick={props.onDuplicate}>{locale.Duplicate}</MenuItem>

      <MenuItem onClick={props.onPublish} disabled={!props.canPublish}>
        Skicka till OneFlow
      </MenuItem>

      <MenuItem onClick={props.onOpenInOneflow} disabled={!props.canOpenInOneflow}>
        Visa i OneFlow
      </MenuItem>

      {props.canUnNullify && (
        <MenuItem onClick={() => props.onNullify(false)}>{locale.UnNullify}</MenuItem>
      )}

      {props.canNullify && (
        <MenuItem onClick={() => props.onNullify(true)}>{locale.Nullify}</MenuItem>
      )}

      <MenuItem onClick={props.onDelete}>{locale.Delete}</MenuItem>
    </Menu>
  );
};
